/**
 * @param {function(number): void} setPercentage
 * @param {string} parentClass
 * @param {number | null} initialPercentage
 * @param {boolean | null} yAxis
 */
export default function dragPercentage(
  setPercentage,
  parentClass,
  initialPercentage,
  yAxis
) {
  const mouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();

    /** @type {HTMLElement} */ let target = e.target;
    while (target.className !== parentClass) {
      target = target.parentElement;
      if (target == null) {
        target = e.target;
        break;
      }
    }

    const rect = target.getBoundingClientRect();
    let percentage;
    if (yAxis) {
      percentage = (rect.bottom - e.clientY) / rect.height;
    } else {
      percentage = (e.clientX - rect.x) / rect.width;
    }

    let startPercentage;

    if (initialPercentage == null) {
      startPercentage = 0;
      if (percentage >= 0 && percentage <= 1) {
        setPercentage(percentage);
      }
    } else {
      startPercentage = percentage;
    }

    const mouseMove = (e2) => {
      let mousePercentage;
      if (yAxis) {
        mousePercentage = (rect.bottom - e2.clientY) / rect.height;
      } else {
        mousePercentage = (e2.clientX - rect.x) / rect.width;
      }
      /*
      if (percentage <= 0) percentage = 0;
      if (percentage >= 1) percentage = 1;
      */
      setPercentage(
        mousePercentage - startPercentage + (initialPercentage || 0)
      );
    };

    const view = e.view;

    view.addEventListener("mousemove", mouseMove);

    const mouseUp = () => {
      view.removeEventListener("mousemove", mouseMove);
      view.removeEventListener("mouseup", mouseUp);
    };
    view.addEventListener("mouseup", mouseUp);
  };

  return mouseDown;
}
